import { produce } from "immer";
import { taskTypes as types } from "../actions";
import { EducatorTaskStateType } from "../../../utils";

const defaultState: EducatorTaskStateType = {
  tasks: [],
  task: null,
  loading: false,
  loaded: false,
  submitLoading: false,
};

const handleSetTasks = (state: any, payload: any) => {
  state.tasks = payload.tasks;
  state.loading = false;
  state.loaded = true;
  return state;
};

const handleSetTaskById = (state: any, payload: any) => {
  state.task = payload.task;
  state.loading = false;
  return state;
};

export default produce(
  (state: EducatorTaskStateType = defaultState, action) => {
    switch (action.type) {
      case types.SET_TASK:
        return handleSetTasks(state, action.payload);
      case types.SET_TASK_BY_ID:
        return handleSetTaskById(state, action.payload);
      case types.GET_TASK:
        return {
          ...state,
          loading: true,
        };
      case types.GET_TASK_BY_ID:
        return {
          ...state,
          loading: true,
        };
      case types.IS_LOADING:
        return {
          ...state,
          submitLoading: action.payload,
        };
      default:
        return state;
    }
  }
);
